import { ForwardedRef, forwardRef, useEffect, useState } from "react";
import Figure, { FigurePosition } from "../../Figure/Figure";
import TextSplit, { TextAlign } from "../../TextSplit/TextSplit";
import './StatisticsSlide.css';
import GlowDiv, { FeatureDivItem } from "../../GlowDiv/GlowDiv";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

const StatisticsSlide = forwardRef((props, ref: ForwardedRef<HTMLDivElement>) => {
  return (
    <Box ref={ref} className="slide-h1" id="statistics" sx={{ flexGrow: 1 }}>
      <Grid container spacing={2} direction="column" alignItems="center" justifyContent="center">
        <Grid className="slide-text-container-grid" item xs={12}>
          <Box className="slide-text-container statistics-text-container" id="statistics-paragraphs"
            sx={{ fontSize: { xs: '20px', sm: '30px', md: '40px', lg: '50px' } }}
          >
            <TextSplit className="slide-body" id="statistics-p-1">
              WE SPECIALIZE IN UNIQUE, HIGH-END, TIGHT TOLERANCE, DIFFICULT TO
              MANUFACTURE COMPONENTS THAT ADVENTURE BEYOND THE ATMOSPHERE; TO MACHINED PARTS THAT WITHSTAND THE EXTREME PRESSURE OF THE OCEAN
              DEPTHS, OUR PARTS EXTEND ACROSS THE MOST DEMANDING AND DIVERSE ENVIRONMENTS.
            </TextSplit>
          </Box>
        </Grid>
        <Grid className="content-slide-grid" item xs={12}>
          <Box className="content-slide" id="stats-bar">
            <Grid className="content-slide-grid" item xs={12}>
              <Box className="content-slide" id="stats-bar">
                <Grid
                  className="feature-row"
                  container
                  justifyContent="center"
                  alignItems="stretch"
                  wrap="nowrap"                 // << keep everything on one line
                  // sx={{border: "2px solid red"}}
                >
                  <GlowDiv>
                    <FeatureDivItem title={"5M+"} description={"Parts Manufactured"} />
                  </GlowDiv>

                  <GlowDiv>
                    <FeatureDivItem title={"30+"} description={"Years in Business"} />
                  </GlowDiv>

                  <GlowDiv>
                    <FeatureDivItem title={"30,000"} description={"Square feet"} />
                  </GlowDiv>
                </Grid>
              </Box>
            </Grid>

          </Box>
        </Grid>
      </Grid>
    </Box>
  );
});

export default StatisticsSlide;